module.exports = __webpack_public_path__ + "static/media/manageAccount.5021143f.svg";